/**
 * Preference Keys
 *
 * Single source of truth for top-level keys in the user preferences JSONB column.
 */

export const PREF_KEYS = {
  THEME: 'theme',
  DISMISSED_BUDGET_SUGGESTIONS: 'dismissed_budget_suggestions',
  NOTIFICATIONS: 'notifications',
  AI: 'ai',
} as const;

export type PrefKey = (typeof PREF_KEYS)[keyof typeof PREF_KEYS];
